export function variablesFromEndpointActionDetails() {
    return {
      restrict: 'E',
      template: require('./variables-from-endpoint-action-details.directive.html'),
      scope: {
        variablesFromEndpoint: "="
      },
      controller: VariablesFromEndpointActionDetailsController
    };
}
  
VariablesFromEndpointActionDetailsController.$inject = ['$scope'];
function VariablesFromEndpointActionDetailsController($scope) {  
}